import { IconArrowUp } from '@tabler/icons-react'

import type { IconComponent } from '@/lib/icons/types'
import type { PlanType } from '@/lib/plans'
import { PLAN_VISUAL_CONFIG } from '@/lib/plans'
import { cn } from '@/lib/utils'

interface PlanIconHeaderProps {
  plan: PlanType | null
  /** Replaces the generic upgrade arrow when there is no plan, for dialogs that
   *  sell a capability rather than a tier. Ignored once `plan` is set, since a
   *  plan always carries its own icon. */
  icon?: IconComponent
}

export function PlanIconHeader({
  plan,
  icon: FallbackIcon = IconArrowUp,
}: PlanIconHeaderProps) {
  if (!plan) {
    return (
      <div className="bg-primary/10 mb-4 flex h-16 w-16 items-center justify-center rounded-2xl">
        <FallbackIcon className="text-link h-8 w-8" />
      </div>
    )
  }

  const visual = PLAN_VISUAL_CONFIG[plan]
  const Icon = visual.icon
  return (
    <div
      className={cn(
        'mb-4 flex h-16 w-16 items-center justify-center rounded-2xl',
        visual.iconBg,
      )}
    >
      <Icon className={cn('h-8 w-8', visual.iconColor)} />
    </div>
  )
}
